// assets/swatch-change-pdp.js

document.addEventListener('DOMContentLoaded', () => {
  // Find and parse product JSON if available
  let product_data = null;
  const product_json_el = document.querySelector('[data-product-json]');
  if (product_json_el) {
    try {
      product_data = JSON.parse(product_json_el.textContent);
      // console.log('[init] product_data loaded:', product_data.title, product_data.variants.length, 'variants');
    } catch (e) {
      // console.warn('[init] could not parse product JSON:', e);
    }
  }

  document.addEventListener('variant:change', (event) => {
    console.log('xxx variant:change swatch-change-pdp.js', event.detail)
    const { variant, currentlySelectedValues } = event.detail || {};
    if (!variant || !currentlySelectedValues || !product_data) return;

    const selected_color = currentlySelectedValues.find((v) => v.index === 'option1')?.value;
    // const selected_size = currentlySelectedValues.find((v) => v.index === 'option2')?.value;

    // console.log('[variant:change]', { selected_color, selected_size, variant_id: variant.id });

    const inputs = document.querySelectorAll('[data-variant-input]');

    inputs.forEach((input) => {
      input.removeAttribute('disabled')
      const is_color = input.classList.contains('variant__input--color-swatch');
      const input_value = input.value;
      const label =
        document.querySelector(`label[for="${CSS.escape(input.id)}"]`) ||
        input.closest('.variant-input')?.querySelector('label') ||
        input.parentElement;

      if (is_color) {
        input.classList.remove('disabled');
        label?.classList.remove('disabled');
        // console.log(`[color] ${input_value} -> always enabled`);
        return;
      }

      // Find variant matching the selected color + this size
      const matching_variant = product_data.variants.find((v) => {
        const v_color = v.option1;
        const v_size = v.option2;
        return v_color === selected_color && v_size === input_value;
      });

      const restricted = matching_variant?.metafields?.custom?.product_restricted === true;
      const available = matching_variant?.available === true;

      if (!matching_variant || restricted || !available) {
        input.classList.add('disabled');
        input.removeAttribute('disabled')
        label?.classList.add('disabled');
      } else {
        input.classList.remove('disabled');
        input.removeAttribute('disabled')
        label?.classList.remove('disabled');
      }
    });
  });
});
